<template>
  <div>
    <b-input-group>
      <CostCenterDropdown
        ref="costCenterDropdown"
        :costCenterId.sync="compCostCenterId"
      />

      <b-input-group-append>
        <b-button v-b-modal.costCenter>
          <i class="tim-icons icon-simple-add" style="text-align: center" />
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      ref="costCenter"
      id="costCenter"
      title="Cadastro: Centro de custo"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
    >
      <div>
        <b-col>
          <cost-center :model.sync="modelLocal" :modelstate="modelstate" />
        </b-col>
      </div>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button
            variant="green"
            @click="saveCostCenter"
            style="margin-left: 5px"
          >
            {{ $t("geral.confirm") }}
          </b-button>

          <b-button class="ml-2" variant="danger" @click="cancelModal">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "CostCenterDropdownModal",
  props: {
    costCenterId: Number,
  },
  components: {
    "cost-center": () =>
      import("@/components_rms/System/CostCenter/costCenter.vue"),
    CostCenterDropdown: () =>
      import("@/components_rms/System/CostCenter/CostCenterDropdown.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "",
      },
      modelstate: [],
      modelLocal: {
        code: null,
        name: null,
        parentCostCenterId: null,
      },
    };
  },
  computed: {
    compCostCenterId: {
      get: function () {
        return this.costCenterId;
      },
      set: function (value) {
        this.$emit("update:costCenterId", value);
      },
    },
  },
  methods: {
    saveCostCenter() {
      this.modelstate = [];
      let obj = {
        code: this.modelLocal.code,
        name: this.modelLocal.name,
        parentCostCenterId: this.modelLocal.parentCostCenterId,
      };
      this.$apiScheduler
        .post("/costCenter/create/", obj)
        .then((response) => {
          this.$refs.costCenterDropdown.loadCostsCenters();
          this.compCostCenterId = parseInt(response.data.id);
          this.clearFields();
          this.cancelModal();
        })
        .catch((error) => {
          if (error.response.data == null) {
            this.modelstate = [];
            this.alert.error = error.response.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errors != null) {
            this.modelstate = error.response.data.errors;
            this.alert.error = error.response.data.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errorMessage) {
            this.modelstate = [];
            this.alert.error = error.response.data.errorMessage;
            this.showToastError();
            return;
          }
        });
    },
    clearFields() {
      this.modelLocal = {
        code: null,
        name: null,
        parentCostCenterId: null,
      };
    },
    cancelModal() {
      this.$refs.costCenter.hide();
    },
    showToastError(append = false) {
      this.$bvToast.toast(this.alert.error, {
        autoHideDelay: 5000,
        toaster: "b-toaster-top-full",
        variant: "danger",
        appendToast: append,
      });
    },
  },
};
</script>